<template>
  <section class="l-content-area">
    <div class="l-content l-content--login">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--login">
            <h1>既存顧客様向け<span>アカウント連携</span></h1>
          </section>

          <section class="p-bloc p-bloc__reservation">
            <div class="p-reservation__bloc">
              <p>
                お客様がいつもご利用されるスタジオを選択してください。
              </p>

              <div class="p-reservation__form">
                <dl class="c-form-parts">
                  <dt>ご利用スタジオ</dt>
                  <dd>
                    <input-select-group
                      :value="values.studio"
                      :text-error="textError"
                      :list-data.sync="listStudio"
                      :list-all-data.sync="listAllStudio"
                      :error="errors"
                      default-value="スタジオをお選びください"
                      name="studio"
                      :value-selected="values.studio"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-select-group>
                  </dd>
                </dl>
                <dl v-if="studioInfo.postal_code || studioInfo.city" class="studio-info">
                  <dt>住所</dt>
                  <dd>
                    <span v-if="studioInfo.postal_code"> 〒{{ studioInfo.postal_code }} </span>
                    <br />
                    <span v-if="studioInfo.city">
                      {{ studioInfo.city }}
                    </span>
                    <span v-if="studioInfo.building">
                      {{ studioInfo.building }}
                    </span>
                    <br />
                  </dd>
                  <dt>営業時間／定休日</dt>
                  <dd v-if="studioInfo.opening_time">
                    <span v-if="studioInfo.opening_time">
                      平日：{{ studioInfo.opening_time }}〜
                    </span>
                    <span v-if="studioInfo.closing_time">
                      {{ studioInfo.closing_time }}
                    </span>
                    <br />
                    <span v-if="studioInfo.alt_opening_time">
                      土・日・祝：{{ studioInfo.alt_opening_time }}〜
                    </span>
                    <span v-if="studioInfo.alt_closing_time">
                      {{ studioInfo.alt_closing_time }}
                    </span>
                    <br />
                    <span v-if="regularHolidayDisplay"> 定休日：{{ regularHolidayDisplay }} </span>
                    <br />
                  </dd>
                  <dt>アクセス</dt>
                  <dd>
                    {{ studioInfo.nearest_station }}
                  </dd>
                </dl>
              </div>
              <div v-if="location" class="p-reservation__map">
                <div id="map">
                  <iframe
                    title="map"
                    :src="location"
                    width="600"
                    height="450"
                    style="border:0;"
                    allowfullscreen=""
                    aria-hidden="false"
                    tabindex="0"
                  >
                  </iframe>
                </div>
              </div>
            </div>

            <button-registration
              next-text="送信する"
              :is-prev-button="false"
              :handle-next-button="nextToStep"
            ></button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonRegistration from '../common/ButtonRegistration'
import { validateRequired } from '../../helpers/schemaValidate'
import { scrollToTop } from '../../helpers'
import InputSelectGroup from '../common/InputSelectGroup'
import { getStoreByState, updateMyStore, getStore, getAllStore } from '../../actions/requestMypage'
import { STUDIO_INVALID } from '../../constant/text'
import { listDayJPName } from '../../constant/listDayJPName'
import { allowedStores } from '../../constant/listStores'

export default {
  name: 'DataSyncStudio',
  components: {
    InputSelectGroup,
    ButtonRegistration,
  },
  props: {
    values: {
      type: Object,
      default: () => {
        return {
          userId: '',
          firstName: '',
          lastName: '',
          phone: '',
          zipCode: '',
          address: '',
          state: '',
          city: '',
          region_id: '',
          studio: '',
        }
      },
    },
    currentStep: {
      type: String,
      default: '3',
    },
    isForceUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      location: '',
      listStudio: [],
      listAllStudio: [],
      listAllStudioInitial: [],
      textError: STUDIO_INVALID,
      errors: '',
      studioInfo: {
        postal_code: '',
        city: '',
        building: '',
        opening_time: '',
        closing_time: '',
        alt_opening_time: '',
        alt_closing_time: '',
        nearest_station: '',
      },
    }
  },
  computed: {
    regularHolidayDisplay() {
      if (this.studioInfo.regular_holidays) {
        let arrregularHoliday = this.studioInfo.regular_holidays
            ? this.studioInfo.regular_holidays.split(',')
            : [],
          listName = [],
          strHoliday = ''
        arrregularHoliday.map((value, index) => {
          if (listDayJPName[value]) {
            listName.push(listDayJPName[value])
          }
        })
        strHoliday = listName.join(', ')
        return strHoliday
      }
      return ''
    },
  },
  watch: {
    'values.state'(newVal) {
      this.getListStudio(newVal)
    },
    'values.studio'(newVal) {
      let studioSelected = this.listStudio.filter(
        studioItem => studioItem.id.toString() === newVal.toString()
      )
      if (studioSelected.length == 0) {
        studioSelected = this.listAllStudio.filter(studio => {
          return studio.id.toString() === newVal.toString()
        })
      }

      if (studioSelected.length > 0) {
        this.studioInfo = studioSelected[0]
        this.location = studioSelected[0]['map']
        sessionStorage.setItem('studioInfo', JSON.stringify(studioSelected[0]))
      } else {
        this.location = null
        this.studioInfo = {
          name: '',
          postal_code: '',
          city: '',
          building: '',
          opening_time: '',
          closing_time: '',
          alt_opening_time: '',
          alt_closing_time: '',
          nearest_station: '',
        }
      }
    },
    isForceUpdate(newVal) {
      if (newVal && this.currentStep === '2') {
        this.nextToStep()
      }
    },
  },
  async created() {
    if (this.values.studio) {
      getStore(this.values.studio)
        .then(res => {
          const {
            data: { success },
          } = res
          if (success) {
            const {
              data: { data },
            } = res
            this.studioInfo = data
          }
        })
        .catch(err => {
          return err
        })
    }
    this.$emit('startLoading')
    await getAllStore()
      .then(res => {
        const {
          data: { success },
        } = res
        if (success) {
          this.listAllStudio = res.data.data
          this.listAllStudioInitial = res.data.data

          // TO BE REMOVED AFTER A REGISTRATION PERIOD
          if (process.env.VUE_APP_NODE_ENV === 'production') {
            this.listAllStudio = this.listAllStudio.filter(studio =>
            allowedStores.includes(studio.name)
            )
            this.listAllStudioInitial = this.listAllStudioInitial.filter(studio =>
            allowedStores.includes(studio.name)
            )
          }
        }
        this.$emit('endLoading')
      })
      .catch(err => {
        this.$emit('endLoading')
        return err
      })
    this.getListStudio(this.values.state)
  },
  methods: {
    onHandleChange(field, value) {
      this.$emit('onHandleChange', field, value)
    },
    onValidate(field, value) {
      this.errors = value
      this.$emit('onValidate', false)
    },
    prevToStep() {
      this.$emit('prevToStep')
    },
    nextToStep() {
      validateRequired('studio', this.textError)
        .validateAt('studio', this.values)
        .then(() => {
          this.$emit('startLoading')
          updateMyStore(this.values.studio)
            .then(response => {
              this.$emit('endLoading')
              const {
                data: { success },
              } = response
              if (success) {
                this.$emit('nextToStep')
              }
            })
            .catch(err => {
              this.$emit('endLoading')
              this.$router.push({ name: 'studio-error' })
              return err
            })
        })
        .catch(error => {
          scrollToTop()
          this.errors = error.message
        })
    },
    getListStudio(stateId) {
      getStoreByState(stateId)
        .then(res => {
          const {
            data: { success },
          } = res
          if (success && success === 1) {
            let state_id = this.state
            this.listStudio = res.data.data

            // TO BE REMOVED AFTER A REGISTRATION PERIOD
            if (process.env.VUE_APP_NODE_ENV === 'production') {
              this.listStudio = this.listStudio.filter(studio => allowedStores.includes(studio.name))
            }

            const listStudioNotSelected = this.listAllStudioInitial.filter(studio => {
              let prefecture_code = studio.prefecture_code
              if (parseInt(prefecture_code.slice(3, 5)) != parseInt(state_id.slice(3, 5))) {
                return studio
              }
            })
            if (listStudioNotSelected.length > 0) {
              this.listAllStudio = listStudioNotSelected
            } else {
              this.listAllStudio = this.listAllStudioInitial
            }
          }
          this.$emit('endLoading')
        })
        .catch(err => {
          this.$emit('endLoading')
          return err
        })
    },
  },
}
</script>

<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}
</style>
